import React from 'react';
import BarSplitChart from './BarSplitChart';

const DeliveryTermsSplitChart = () => (
  <BarSplitChart
    title="Split Over Delivery Terms"
    endpoint="/dashboard/delivery-terms-split"
    cornerLabel="count"
    barColor="var(--dash-chart-5)"
    maxRows={7}
  />
);

export default DeliveryTermsSplitChart;
